export enum ItemSortFilter {
    DEFAULT = 'DEFAULT',
    TITLE = 'TITLE',
    RELEASE_DATE = 'RELEASE_DATE',
    EDITION_SIZE = 'EDITION_SIZE',
    ESTIMATED_PRICE = 'ESTIMATED_PRICE',
    MARKET_VOLUME = 'MARKET_VOLUME',
    BIGGEST_MARKET_CHANGE = 'BIGGEST_MARKET_CHANGE',
    LAST_SALE_DATE = 'LAST_SALE_DATE'
}